module.exports = __webpack_public_path__ + "img/generales.4dabe006.png";